import {
  ArrowUpRightIcon,
  CalculatorIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  Cog6ToothIcon,
  EyeIcon,
  HeroIconProps,
  InformationCircleIcon,
  XMarkIcon,
} from 'components'
import {
  DocumentIcon,
  EllipsisHorizontalCircleIcon,
  GlobeAltIcon,
  LeaveIcon,
  PlayCircleIcon,
  PlusIcon,
  QrCodeIcon,
} from 'components/icons'
import { ScaleProps, useScaleProps } from '../../utils/scaleUtils'

export interface Props extends ScaleProps<Omit<HeroIconProps, 'children'>> {
  value: HeroIcon
}

export type HeroIcon =
  | 'arrow-up-right'
  | 'calculator'
  | 'chat'
  | 'chevron-left'
  | 'chevron-right'
  | 'close'
  | 'cog6Tooth'
  | 'document'
  | 'ellipsis-horizontal-circle'
  | 'eye'
  | 'globe-alt'
  | 'info'
  | 'leave'
  | 'play-circle'
  | 'plus-circle'
  | 'qr-code'

export default function SIcon({ value, ...props }: Props) {
  const { styleProps, rest } = useScaleProps(props)
  const _props = { ...styleProps, ...rest }

  switch (value) {
    case 'arrow-up-right':
      return <ArrowUpRightIcon {..._props} />
    case 'calculator':
      return <CalculatorIcon {..._props} />
    case 'chat':
      return <ChatBubbleOvalLeftEllipsisIcon {..._props} />
    case 'chevron-left':
      return <ChevronLeftIcon {..._props} />
    case 'chevron-right':
      return <ChevronRightIcon {..._props} />
    case 'close':
      return <XMarkIcon {..._props} />
    case 'cog6Tooth':
      return <Cog6ToothIcon {..._props} />
    case 'eye':
      return <EyeIcon {..._props} />
    case 'info':
      return <InformationCircleIcon type="outline" {..._props} />
    case 'leave':
      return <LeaveIcon {..._props} />
    case 'play-circle':
      return <PlayCircleIcon {..._props} />
    case 'ellipsis-horizontal-circle':
      return <EllipsisHorizontalCircleIcon {..._props} />
    case 'globe-alt':
      return <GlobeAltIcon {..._props} />
    case 'document':
      return <DocumentIcon {..._props} />
    case 'plus-circle':
      return <PlusIcon {..._props} />
    case 'qr-code':
      return <QrCodeIcon {..._props} />
  }
}
